document.addEventListener("DOMContentLoaded", function() {
  var typingTimer;
  var doneTypingInterval = 1000; // Time in ms (1 second)
  var input = document.getElementById('faqs-search');
  const faqWrappers = document.querySelectorAll('.faqs-questions--wrapper');
  const searchError = document.querySelector('.search-error');
  const searchBar = document.querySelector('.faqs-search-bar');

  // On keyup event for search
  input.addEventListener('keyup', function() {
    clearTimeout(typingTimer);
    if (input.value.trim().length > 0) {
      typingTimer = setTimeout(filterFAQs, doneTypingInterval);
    }
    searchError.classList.add('hide');
    searchBar.classList.remove('show-error');
  });

  function filterFAQs() {
    var input, filter, txtValue, matchFound = false;
    input = document.getElementById('faqs-search');
    filter = input.value.trim().toLowerCase();

    // Check if the input has more than 3 words
    if (filter.length >= 2) {
      faqWrappers.forEach(wrapper => {
        txtValue = wrapper.textContent || wrapper.innerText;

        if (txtValue.toLowerCase().indexOf(filter) > -1) {
          matchFound = true;
          wrapper.classList.add('active');  // Open this FAQ          

          // Close other FAQ answers
          faqWrappers.forEach(otherWrapper => {
            if (otherWrapper !== wrapper) {
              otherWrapper.classList.remove('active');
            }
          });

          setTimeout(() => {
            wrapper.scrollIntoView({ behavior: "smooth", block: "start" }); // Scroll to it            
          },300);
        } else {
          wrapper.classList.remove('active');
        }
      });

      // If no matches are found
      if (!matchFound) {
        // Show the error message by removing 'hide' and adding 'show-error' to parent
        searchError.classList.remove('hide');
        searchBar.classList.add('show-error');
      } else {
        // Hide the error message if matches are found
        searchError.classList.add('hide');
        searchBar.classList.remove('show-error');
      }
    }
  }
});
